import { toAbsoluteUrl } from '../../utils/toAbsoluteUrl';
import React from 'react';
import InlineSVG from 'react-inlinesvg';

export default class NavigationListItemContent extends React.Component {
	/**  @returns {JSX.Element} */
	render() {
		const submenuIconStyle = this.props.isSubmenu
			? {
					flex: '0 0 28px',
					height: '28px',
					marginRight: '0.75rem',
					minWidth: '28px',
					width: '28px',
			  }
			: undefined;
		const submenuSvgStyle = this.props.isSubmenu
			? { display: 'block', height: '28px', width: '28px' }
			: undefined;

		return (
			<React.Fragment>
				<i className="icon" style={submenuIconStyle}>
					<InlineSVG
						src={toAbsoluteUrl(this.props.icon)}
						style={submenuSvgStyle}
					/>
				</i>
				{this.props.children}
			</React.Fragment>
		);
	}
}
